import { Helmet } from "react-helmet-async";

function Disclaimer() {
  return (
    <div className="max-w-3xl mx-auto p-6 text-gray-800">
      {/* 🔹 SEO Meta Tags */}
      <Helmet>
        <title>Disclaimer - Build Pro Resume</title>
        <meta
          name="description"
          content="Read the disclaimer for Build Pro Resume. We provide information in good faith but do not guarantee accuracy or completeness."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* 🔹 Disclaimer Content */}
      <h1 className="text-3xl font-bold mb-4">Disclaimer</h1>
      <p className="mb-4">
        The information provided by <strong>Build Pro Resume</strong> is for
        general informational purposes only. While we strive to ensure the
        accuracy and reliability of the content, we make no guarantees, express
        or implied, regarding its completeness, adequacy, or accuracy.
      </p>
      <p className="mb-4">
        Any actions you take based on the information found on this site are
        strictly at your own risk. <strong>Build Pro Resume</strong> will not be
        liable for any losses or damages in connection with the use of our
        website.
      </p>
      <p>
        If you have any concerns, please contact us at{" "}
        <a
          href="mailto:support@buildproresume.com"
          className="text-blue-500 underline hover:text-blue-700"
        >
          support@buildproresume.com
        </a>
        .
      </p>

      {/* 🔹 Image Attribution (Now placed properly) */}
      <div className="mt-6 text-xs text-gray-600">
        <a
          href="https://unsplash.com/photos/white-printer-paper-on-macbook-pro-4YzrcDNcRVg"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-blue-400"
        >
          Image by Unsplash
        </a>
      </div>
    </div>
  );
}

export default Disclaimer;
